import { getWrapperClassName, IconProps } from '@/components/design-system/utils'
import React from 'react'

export const TLIconFacebook = (props: IconProps) => {
  const height = `${ props.height }px`
  const width = `${ props.width }px`
  return (
      <svg
          className={ getWrapperClassName(props.className, '') }
          viewBox="0 0 36 36"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height={ height }
          width={ width }>
        { props.tooltip && <title>{ props.tooltip }</title> }
        <path
            d="M33.3885 17.6942C33.3885 26.3619 26.3619 33.3885 17.6942 33.3885C9.02655 33.3885 2 26.3619 2 17.6942C2 9.02655 9.02655 2 17.6942 2C26.3619 2 33.3885 9.02655 33.3885 17.6942Z"
            fill="currentColor"/>
        <path
            d="M15.1832 22.4025V33.0746C15.1832 33.2479 15.3237 33.3885 15.497 33.3885H19.8914C20.0648 33.3885 20.2053 33.2479 20.2053 33.0746V22.4025C20.2053 22.2292 20.3458 22.0886 20.5192 22.0886H23.658C23.8314 22.0886 23.9719 21.9481 23.9719 21.7747V18.0081C23.9719 17.8348 23.8314 17.6942 23.658 17.6942H20.5192C20.3458 17.6942 20.2053 17.5539 20.2053 17.3806V14.5554C20.2053 13.2998 21.7747 12.6721 22.4025 12.6721H24.2858C24.4592 12.6721 24.5997 12.5315 24.5997 12.3582V8.59158C24.5997 8.41823 24.4592 8.27769 24.2859 8.27769H20.2053C17.192 8.27769 15.1832 11.4165 15.1832 13.2998V17.3804C15.1832 17.5537 15.0426 17.6942 14.8693 17.6942H11.7304C11.5571 17.6942 11.4165 17.8348 11.4165 18.0081V21.7747C11.4165 21.9481 11.5571 22.0886 11.7304 22.0886H14.8693C15.0426 22.0886 15.1832 22.2292 15.1832 22.4025Z"
            fill="white"/>
      </svg>
  )
}

TLIconFacebook.defaultProps = {
  className: '',
  height: 36,
  width: 36,
  tooltip: null
}
